import React from "react";
import { AuthProvider } from "./contexts/AuthContext";
import { ToastProvider } from "./contexts/ToastContext";
import Routes from "./Routes";
import CreditUsageNotification from "./components/CreditUsageNotification";
import ScrollProgressBar from "./components/ScrollProgressBar";

function App() {
  return (
    <AuthProvider>
      <ToastProvider>
        <ScrollProgressBar />
        <Routes />
        <CreditUsageNotification />
      </ToastProvider>
    </AuthProvider>
  );
}

export default App;